export default {
  nome: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  document: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  numeroPA: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  diaAtrasoInicio: {
    value: '',
    required: false,
    state: null
  },
  diaAtrasoFinal: {
    value: '',
    required: false,
    state: null
  },
  nomeRegional: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  utmCampaign: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  utmSource: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  utmMedium: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  utmContent: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  utmTerm: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  situacao: {
    value: null,
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/search/search-form.js